module.exports = __webpack_public_path__ + "img/empty.bed8cc52.png";